import availability from './availability';
import templates from './templates';
import insights from './insights';

export default {
  en: {
    form: {
      title: {
        label: 'Title',
        hint: 'Visible title for your customers',
        placeholder: 'Enter the title',
      },
      description: {
        label: 'Description',
        hint: 'Description of the service (not visible for customers)',
        placeholder: 'Enter a description'
      },
      automaticSelection: {
        label: 'Automatic agent assigment',
        hint: 'Smart algorithm to balance and assign appointments to agents',
      },
      identifier: {
        label: 'Internal Id (optional)',
        hint: 'Fill with internal id to be used in your integrations like Webhooks',
        placeholder: 'Enter a internal id',
      },
      visibility: {
        label: 'Visibility',
        hint: 'Choose if you want show or hide this calendar into your integrations',
      },
      reminders: {
        label: 'Reminders',
        hint: 'Reminders emails that will be sent to customers and agents',
        empty: 'No reminders defined',
        placeholderTime: 'Enter the time as number',
        addReminder: 'Add a reminder',
      },
      logo: {
        label: 'Email logo',
        hint: 'The logo wil be visible in the emails templates',
        placeholder: 'Enter a valid URL',
      },
      availability: {
        label: 'Availability',
        hint: 'Calendar hours and dates',
        placeholder: 'Select an availability',
      },
      customerForm: {
        label: 'Customer form',
        hint: 'Form needs to be filled by the customer',
        alert: 'The form needs to have at least an email field',
        placeholder: 'Select an customer\'s form'
      },
      survey: {
        label: 'Survey',
        hint: 'Survey filled by the customer at the end of the meeting',
        placeholder: 'Select a survey'
      },
      agentForm: {
        label: 'Agent form',
        hint: 'Set a form need to be filled by yours agents',
        placeholder: 'Select an agent form'
      },
      emailTemplates: {
        label: 'Custom email templates',
        hint: 'Select custom email template to be use for replace the default one',
        placeholder: 'Select a survey'
      },
      recording: {
        label: 'Recording setting',
        hint: 'Select the recording setting for this calendar',
        placeholder: 'Select an agent form'
      },
      agents: {
        placeholder: 'Select agents assigned'
      }
    },
    view: {
      supervisionTitle: 'Real-time supervision',
      supervisionWarning: 'Note that using real-time supervision could affect the latency of the communication.',
      connected: 'Connected',
      disconnected: 'Disconnected',
      spyModeButton: 'Start supervision',
      spyMode: {
        errorTitle: 'Live supervision error',
        errorDefault: 'Could not start live supervision. Please try again later.',
        '451': 'The feature is not enabled by the administrator',
        '403': 'You do not have permission to supervise meetings',
      },
      details: {
        status: 'Status',
        confirmation: 'Confirmation',
        confirmed: 'Confirmed',
        notConfirmed: 'Not confirmed',
        agentConnectedAt: 'Agent joined at',
        customerConnectedAt: 'Customer joined at',
        notConnected: 'Did not join',
        rescheduleTitle: 'Rescheduling',
        rescheduledBy: 'Rescheduled by',
        viewRescheduled: 'View new appointment',
        thisAppointment: 'This appointment',
        newAppointment: 'New appointment',
        cancellationTitle: 'Cancellation',
        canceledBy: 'Canceled by',
        canceledAt: 'Canceled at',
        cancelReason: 'Reason',
        noReason: 'No reason provided',
        accessLinks: 'Access links',
        joinUrl: 'Join link',
        modifyUrl: 'Modify link',
        thirdPartyInvite: 'Third-party invite',
        open: 'Open',
        authorizationsTitle: 'Room access requests',
        session: 'Session',
        requestedAt: 'Requested at',
        authorizedAt: 'Authorized at',
        byAgent: 'Agent',
        byCustomer: 'Customer',
        authStatuses: {
          pending: 'Pending',
          accepted: 'Accepted',
          denied: 'Denied',
          abandoned: 'Abandoned',
        },
      },
    },
    availability: availability.en,
    templates: templates.en,
    insights: insights.en,
  },
  es: {
    placeholder: 'Selecciona una plantilla de correo',
    form: {
      title: {
        label: 'Título',
        hint: 'Título visible para tus clientes',
        placeholder: 'Ingresa el título',
      },
      description: {
        label: 'Descripción',
        hint: 'Descripción del servicio (no visible para los clientes)',
        placeholder: 'Ingresa una descripción'
      },
      automaticSelection: {
        label: 'Asignación automática de agentes',
        hint: 'Algoritmo inteligente para equilibrar y asignar citas a los agentes',
      },
      identifier: {
        label: 'ID interno (opcional)',
        hint: 'Llena con el ID interno para ser utilizado en tus integraciones como Webhooks',
        placeholder: 'Ingresa un ID interno',
      },
      visibility: {
        label: 'Visibilidad',
        hint: 'Elige si deseas mostrar u ocultar este calendario en tus integraciones',
      },
      reminders: {
        label: 'Recordatorios',
        hint: 'Correos electrónicos de recordatorio que se enviarán a los clientes y agentes',
        empty: 'No se definieron recordatorios',
        placeholderTime: 'Ingresa el tiempo como número',
        addReminder: 'Agregar un recordatorio',
      },
      logo: {
        label: 'Logo de correo',
        hint: 'El logo será visible en las plantillas de correo',
        placeholder: 'Ingresa una URL válida',
      },
      availability: {
        label: 'Disponibilidad',
        hint: 'Horas y fechas del calendario',
        placeholder: 'Selecciona una disponibilidad',
      },
      customerForm: {
        label: 'Formulario del cliente',
        hint: 'Formulario que necesita ser llenado por el cliente',
        alert: 'El formulario necesita tener al menos un campo de correo electrónico',
        placeholder: 'Selecciona un formulario del cliente'
      },
      survey: {
        label: 'Encuesta',
        hint: 'Encuesta llenada por el cliente al final de la reunión',
        placeholder: 'Selecciona una encuesta'
      },
      agentForm: {
        label: 'Formulario del agente',
        hint: 'Establece un formulario que necesita ser llenado por tus agentes',
        placeholder: 'Selecciona un formulario de agente'
      },
      emailTemplates: {
        label: 'Plantillas de correo personalizadas',
        hint: 'Selecciona la plantilla de correo personalizada para reemplazar la predeterminada',
        placeholder: 'Selecciona una plantilla de correo'
      },
      recording: {
        label: 'Configuración de grabación',
        hint: 'Selecciona la configuración de grabación para este calendario'
      },
      agents: {
        placeholder: 'Selecciona agentes asignados'
      },
    },
    view: {
      supervisionTitle: 'Supervisión en tiempo real',
      supervisionWarning: 'Considere que el uso de supervisión en tiempo real podría afectar en la latencia en la comunicación.',
      connected: 'Conectado',
      disconnected: 'Desconectado',
      spyModeButton: 'Iniciar supervisión',
      spyMode: {
        errorTitle: 'Error en supervisión en vivo',
        errorDefault: 'No se pudo iniciar la supervisión en vivo. Por favor, inténtelo de nuevo más tarde.',
        '451': 'La función no está activada por el administrador',
        '403': 'No tienes permiso para supervisar reuniones',
      },
      details: {
        status: 'Estado',
        confirmation: 'Confirmación',
        confirmed: 'Confirmada',
        notConfirmed: 'Sin confirmar',
        agentConnectedAt: 'Agente se conectó',
        customerConnectedAt: 'Cliente se conectó',
        notConnected: 'No se conectó',
        rescheduleTitle: 'Reagendamiento',
        rescheduledBy: 'Reagendada por',
        viewRescheduled: 'Ver nueva cita',
        thisAppointment: 'Esta cita',
        newAppointment: 'Nueva cita',
        cancellationTitle: 'Cancelación',
        canceledBy: 'Cancelada por',
        canceledAt: 'Cancelada el',
        cancelReason: 'Motivo',
        noReason: 'Sin motivo indicado',
        accessLinks: 'Enlaces de acceso',
        joinUrl: 'Enlace de ingreso',
        modifyUrl: 'Enlace de modificación',
        thirdPartyInvite: 'Invitación a terceros',
        open: 'Abrir',
        authorizationsTitle: 'Solicitudes de acceso a la sala',
        session: 'Sesión',
        requestedAt: 'Solicitado el',
        authorizedAt: 'Autorizado el',
        byAgent: 'Agente',
        byCustomer: 'Cliente',
        authStatuses: {
          pending: 'Pendiente',
          accepted: 'Aceptada',
          denied: 'Rechazada',
          abandoned: 'Abandonada',
        },
      },
    },
    availability: availability.es,
    templates: templates.es,
    insights: insights.es,
  },
  fr: {
    form: {
      title: {
        label: 'Titre',
        hint: 'Titre visible pour vos clients',
        placeholder: 'Entrez le titre',
      },
      description: {
        label: 'Description',
        hint: 'Description du service (non visible pour les clients)',
        placeholder: 'Entrez une description'
      },
      automaticSelection: {
        label: 'Attribution automatique des agents',
        hint: 'Algorithme intelligent pour équilibrer et attribuer les rendez-vous aux agents',
      },
      identifier: {
        label: 'Identifiant interne (optionnel)',
        hint: 'Remplir avec un identifiant interne à utiliser dans vos intégrations comme les Webhooks',
        placeholder: 'Entrez un identifiant interne',
      },
      visibility: {
        label: 'Visibilité',
        hint: 'Choisissez si vous souhaitez afficher ou cacher ce calendrier dans vos intégrations',
      },
      reminders: {
        label: 'Rappels',
        hint: 'E-mails de rappel envoyés aux clients et aux agents',
        empty: 'Aucun rappel défini',
        placeholderTime: 'Entrez l’heure en nombre',
        addReminder: 'Ajouter un rappel',
      },
      logo: {
        label: 'Logo des e-mails',
        hint: 'Le logo sera visible dans les modèles d’e-mails',
        placeholder: 'Entrez une URL valide',
      },
      availability: {
        label: 'Disponibilité',
        hint: 'Heures et dates du calendrier',
        placeholder: 'Sélectionnez une disponibilité',
      },
      customerForm: {
        label: 'Formulaire client',
        hint: 'Formulaire à remplir par le client',
        alert: 'Le formulaire doit avoir au moins un champ email',
        placeholder: 'Sélectionnez un formulaire client'
      },
      survey: {
        label: 'Enquête',
        hint: 'Enquête remplie par le client à la fin de la réunion',
        placeholder: 'Sélectionnez une enquête'
      },
      agentForm: {
        label: 'Formulaire agent',
        hint: 'Définir un formulaire à remplir par vos agents',
        placeholder: 'Sélectionnez un formulaire agent'
      },
      emailTemplates: {
        label: 'Modèles d’e-mails personnalisés',
        hint: 'Sélectionnez un modèle d’e-mail personnalisé pour remplacer le modèle par défaut',
        placeholder: 'Sélectionnez un modèle'
      },
      recording: {
        label: 'Paramètres d’enregistrement',
        hint: 'Sélectionnez les paramètres d’enregistrement pour ce calendrier',
        placeholder: 'Sélectionnez un formulaire agent'
      },
      agents: {
        placeholder: 'Sélectionnez les agents assignés'
      }
    },
    view: {
      supervisionTitle: 'Supervision en temps réel',
      supervisionWarning: 'Notez que l’utilisation de la supervision en temps réel pourrait affecter la latence de la communication.',
      connected: 'Connecté',
      disconnected: 'Déconnecté',
      spyModeButton: 'Démarrer la supervision',
      spyMode: {
        errorTitle: 'Erreur de supervision en direct',
        errorDefault: 'Impossible de démarrer la supervision en direct. Veuillez réessayer plus tard.',
        '451': 'La fonction n\'est pas activée par l\'administrateur',
        '403': 'Vous n\'avez pas la permission de superviser les réunions',
      },
      details: {
        status: 'Statut',
        confirmation: 'Confirmation',
        confirmed: 'Confirmé',
        notConfirmed: 'Non confirmé',
        agentConnectedAt: 'Agent connecté à',
        customerConnectedAt: 'Client connecté à',
        notConnected: 'Ne s\'est pas connecté',
        rescheduleTitle: 'Reprogrammation',
        rescheduledBy: 'Reprogrammé par',
        viewRescheduled: 'Voir le nouveau rendez-vous',
        thisAppointment: 'Ce rendez-vous',
        newAppointment: 'Nouveau rendez-vous',
        cancellationTitle: 'Annulation',
        canceledBy: 'Annulé par',
        canceledAt: 'Annulé le',
        cancelReason: 'Motif',
        noReason: 'Aucun motif fourni',
        accessLinks: 'Liens d\'accès',
        joinUrl: 'Lien de connexion',
        modifyUrl: 'Lien de modification',
        thirdPartyInvite: 'Invitation tierce',
        open: 'Ouvrir',
        authorizationsTitle: 'Demandes d\'accès à la salle',
        session: 'Session',
        requestedAt: 'Demandé le',
        authorizedAt: 'Autorisé le',
        byAgent: 'Agent',
        byCustomer: 'Client',
        authStatuses: {
          pending: 'En attente',
          accepted: 'Acceptée',
          denied: 'Refusée',
          abandoned: 'Abandonnée',
        },
      },
    },
    availability: availability.fr,
    templates: templates.fr,
    insights: insights.fr,
  }
}
